import React from "react";
import styled from "styled-components";

/**
 * HOME 進行中ホイールの末尾に常駐する「待機中」スロット。
 *
 * 旧 WaitingSummaryCard（枠付きカード + サムネイルのモザイク一覧）を置き換え、
 * カード枠・背景を持たずスロット中央にラベル（鋭意制作中 / レビュー待ち）だけを
 * 表示する。待機中ショットのサムネイルは、このスロットが選択されたときに
 * WaitingShotCloud（body ポータルのオーバーレイ）がラベルの周囲へ雲状に散らす。
 *
 * クリックはそのまま Slot（カード選択）へ素通しする。
 */

const CenterWrapper = styled.div<{ $selected: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ $selected }) => ($selected ? 1 : 0.4)};
  transition: opacity 0.3s ease;
`;

export interface WaitingLabelCardProps {
  selected: boolean;
  /** 「鋭意制作中」（CLIENT/REVIEWER）または「レビュー待ち」（PRODUCER 系）。 */
  title: string;
}

const WaitingLabelCard: React.FC<WaitingLabelCardProps> = ({
  selected,
  title,
}) => (
  <CenterWrapper $selected={selected}>
    {/* 文字色は継承に任せず明示する（WaitingShotCloud のチップと同じ揃え方） */}
    <span className="heading-spacing-18 u-line-height-150 u-text-black">
      {title}
    </span>
  </CenterWrapper>
);

export default WaitingLabelCard;
